import { ClientEnvironment } from "~/environment/ClientEnvironment";

export async function generateApiKey(environment: ClientEnvironment) {
  const response = await environment.api.generateApiKey({});
  if (response.status === 200 && response.body.recordMap) {
    environment.writeRecordMap(response.body.recordMap);
  }
}
